/**
 * @generated SignedSource<<bcd06d3dafdb13df26ee25780903c4da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AdminListAccountsRequest = {
  includeArchived?: boolean | null;
  pageNumber?: number | null;
  pageSize?: number | null;
  search?: string | null;
};
export type UserFormDialogAccountsQuery$variables = {
  input: AdminListAccountsRequest;
};
export type UserFormDialogAccountsQuery$data = {
  readonly adminListAccounts: {
    readonly data: ReadonlyArray<{
      readonly featureFlagIds: ReadonlyArray<string>;
      readonly id: string;
      readonly name: string;
    }>;
  };
};
export type UserFormDialogAccountsQuery = {
  response: UserFormDialogAccountsQuery$data;
  variables: UserFormDialogAccountsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminAccountList",
    "kind": "LinkedField",
    "name": "adminListAccounts",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminAccount",
        "kind": "LinkedField",
        "name": "data",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "featureFlagIds",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserFormDialogAccountsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserFormDialogAccountsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f5ac804753b68e72cacbf1b3c5ca1843",
    "id": null,
    "metadata": {},
    "name": "UserFormDialogAccountsQuery",
    "operationKind": "query",
    "text": "query UserFormDialogAccountsQuery(\n  $input: AdminListAccountsRequest!\n) {\n  adminListAccounts(input: $input) {\n    data {\n      id\n      name\n      featureFlagIds\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fb95c561850a4dbb1f3a44e181ae9e37";

export default node;
